<template>
  <div>
    <KidLoginPage v-if="isKidDomain" />
    <v-container v-else fluid class="pa-0">
      <IntroSection />
      <FeatureSection />
      <ParentIntroSection />
      <ChildIntroSection />
      <ProductSection />
    </v-container>
  </div>
</template>

<script>
  import IntroSection from "@/components/LandingPage/IntroSection";
  import FeatureSection from "@/components/LandingPage/FeatureSection";
  import ParentIntroSection from "@/components/LandingPage/ParentIntroSection";
  import ChildIntroSection from "@/components/LandingPage/ChildIntroSection";
  import ProductSection from "@/components/LandingPage/ProductSection";
  import KidLoginPage from "@/components/KidLoginPage";

  export default {
    name: "Home",

    computed: {
      isKidDomain() {
        return window.location.hostname.includes("easiclub");
      },
    },

    components: {
      IntroSection,
      FeatureSection,
      ParentIntroSection,
      ChildIntroSection,
      ProductSection,
      KidLoginPage,
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/LandingPage/Home.vue